/**
 * @generated SignedSource<<695e13ceb9c9fd9a1f0d9856c3df8b3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSupportTicketDetailRelayQuery$variables = {
  id: string;
};
export type useSupportTicketDetailRelayQuery$data = {
  readonly getSupportTicket: {
    readonly closedDate: any | null | undefined;
    readonly communicationLog: ReadonlyArray<any> | null | undefined;
    readonly content: string | null | undefined;
    readonly created: any | null | undefined;
    readonly deviceId: string | null | undefined;
    readonly hardware: {
      readonly hardwareType: {
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly maintenanceTickets: ReadonlyArray<{
      readonly canceledOn: any | null | undefined;
      readonly completedOn: any | null | undefined;
      readonly description: string;
      readonly dueOn: any;
      readonly id: string;
      readonly oldId: string | null | undefined;
      readonly status: string | null | undefined;
    }>;
    readonly notes: string | null | undefined;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly owner: string | null | undefined;
    readonly rental: {
      readonly id: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly state: number | null | undefined;
    readonly subtype: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly tags: ReadonlyArray<string> | null | undefined;
    readonly type: number | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string;
      readonly fullName: string | null | undefined;
      readonly id: string;
      readonly lastName: string;
      readonly phone: string;
    } | null | undefined;
  } | null | undefined;
};
export type useSupportTicketDetailRelayQuery = {
  response: useSupportTicketDetailRelayQuery$data;
  variables: useSupportTicketDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closedDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtype",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "communicationLog",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Rental",
  "kind": "LinkedField",
  "name": "rental",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "System",
  "kind": "LinkedField",
  "name": "system",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemOldId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MaintenanceTicket",
  "kind": "LinkedField",
  "name": "maintenanceTickets",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canceledOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSupportTicketDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SupportTicket",
        "kind": "LinkedField",
        "name": "getSupportTicket",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hardware",
            "kind": "LinkedField",
            "name": "hardware",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HardwareType",
                "kind": "LinkedField",
                "name": "hardwareType",
                "plural": false,
                "selections": [
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSupportTicketDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SupportTicket",
        "kind": "LinkedField",
        "name": "getSupportTicket",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hardware",
            "kind": "LinkedField",
            "name": "hardware",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HardwareType",
                "kind": "LinkedField",
                "name": "hardwareType",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63757488c74e71581f5c88830c0a25a8",
    "id": null,
    "metadata": {},
    "name": "useSupportTicketDetailRelayQuery",
    "operationKind": "query",
    "text": "query useSupportTicketDetailRelayQuery(\n  $id: ID!\n) {\n  getSupportTicket(id: $id) {\n    id\n    oldId\n    state\n    content\n    created\n    closedDate\n    owner\n    tags\n    type\n    subtype\n    deviceId\n    communicationLog\n    notes\n    user {\n      id\n      phone\n      fullName\n      firstName\n      lastName\n      email\n    }\n    hardware {\n      id\n      oldId\n      number\n      hardwareType {\n        name\n        id\n      }\n    }\n    rental {\n      id\n      oldId\n    }\n    system {\n      id\n      oldId\n      name\n    }\n    organizationId\n    systemId\n    systemOldId\n    maintenanceTickets {\n      id\n      oldId\n      dueOn\n      completedOn\n      canceledOn\n      status\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ac8d8a83cee9be26b33323038d69cfc";

export default node;
